import { render, staticRenderFns } from "./UlBreadcrumbs.vue?vue&type=template&id=647032a8&"
import script from "./UlBreadcrumbs.vue?vue&type=script&lang=ts&"
export * from "./UlBreadcrumbs.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports